import { Component, ViewChild, ElementRef, Inject } from '@angular/core';
import { PageComponent } from '../page/page.component';
import { GlobalsService } from '../../services/globals.service';
import { StorageService } from '../../services/storage.service';
import { ViasConnectionService, ViasResponse } from '../../services/vias-connection.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageMeta, ResponseFieldDataSourceType } from '../../services/page-meta.service';
import { TranslateService } from '@ngx-translate/core';
import { FormComponent } from '../form/form.component';
import { FormItem, ServiceCall, FormOption, FormEvent } from '../form/FormItem';
import { first } from 'rxjs/operators';
import { FieldTypes } from '../../FieldTypes';
import { AlertType } from '../../services/vias-alert.service';
import { DialogFields } from '../../services/vias-dialog.service';
@Component({
  selector: 'vias-default-edit-page',
  templateUrl: '../page/page.component.html',
  styleUrls: ['../page/page.component.scss']
})
export class DefaultEditPageComponent extends PageComponent {
  // formRef init olunca set ediliyor, yokdsa null
  formRefx;
  @ViewChild('form', { static: false }) set formRef(form: ElementRef | null) {
    if (!form) { return; }
    this.afterFormInit(form);
  }

  formSubmitFields: object = {};

  tableAddDialogRun: ($event) => void;

  constructor(
    protected storage: StorageService,
    protected globals: GlobalsService,
    protected viasService: ViasConnectionService,
    protected next: ActivatedRoute,
    protected route: Router,
    protected translate: TranslateService,
    public tableDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) protected dialogData: {} = {},
    protected dialogRef: MatDialogRef<DefaultEditPageComponent>,
  ) {
    super(storage, globals, viasService, next, route, translate, dialogData);
    this.hasDatagrid = false;
    this.hasEditForm = true;
  }

  afterFormInit(form): void {
    // formRef init olunca set ediliyor, yokdsa null
    this.formRefx = form;
    form.formChange.subscribe(changed => {
      // item bul
      const item: FormItem = this.formItems.find(e => e.name === changed.itemName);

      if (item.onChangedServiceCall !== undefined) {
        const csca: ServiceCall[] = item.onChangedServiceCall;
        csca.forEach(csc => {
          let data: object = {};
          data[csc.data] = changed.val;
          if (csc.initData !== undefined) {
            data = {
              ...data,
              ...csc.initData
            };
          }
          this.viasService.send(
            csc.pid,
            csc.aid,
            data
          )
            .then(r => {
              console.log(r);
              if (r.error) {
                this.globals.handleErrors(r.error);
              }
              if (r.data !== undefined) {
                if (r.data[csc.returnField] !== undefined) {
                  // baska alana deger olarak gir
                  // serviceWorkStatusEditMode bu alan true ise edit modunda da çalışacak
                  // tslint:disable-next-line: triple-equals
                  if (csc.otherFieldVal !== undefined && (csc.serviceWorkStatusEditMode == true || this.loadAid != 3)) {
                    form.form.get(csc.otherFieldVal).setValue(r.data[csc.returnField]);
                    // baska alana data source
                  } else if (csc.otherFieldDataSource !== undefined) {
                    const fItem: FormItem = form.formItems.find(e => e.name === csc.otherFieldDataSource);
                    const res = r.data[csc.returnField];
                    const opt: FormOption[] = [];
                    for (const s in res) {
                      if (s !== undefined) {
                        opt.push({
                          label: res[s][fItem.optionsDataLabelField],
                          data: res[s][fItem.optionsDataIdField]
                        });
                      }
                    }
                    fItem.options = opt;
                  }
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
      }
      // onchange fonk varsa calistir
      if (item.onChangedFunc !== undefined) {
        console.log(item.onChangedFunc);
        item.onChangedFunc(changed.val, this);
      }
    });
  }

  generatePageFromMeta(pageMeta: PageMeta): void {
    super.generatePageFromMeta(pageMeta);
    // this.aid = pageMeta.inspectAid;
    this.editPid = pageMeta.editPid;
    this.submitAid = pageMeta.submitAid;
    this.hasButtonbar = pageMeta.hasButtonBarInEdit;
    this.dgButtons = {
      hasAddBtn: pageMeta.datagridHasAddBtn,
      hasEditBtn: pageMeta.datagridHasEditBtn,
      hasDeleteBtn: pageMeta.datagridHasDeleteBtn
    };

    let disabledOnInspect = false;
    if (pageMeta.formDisableFunctionOnLoad !== undefined) {
      disabledOnInspect = pageMeta.formDisableFunctionOnLoad();
    } else if (this.loadAid === pageMeta.inspectAid) {
      disabledOnInspect = true;
    }

    if (pageMeta.formItems !== undefined) {
      pageMeta.formItems.forEach(fi => {

        // disabledOnInspect
        if (fi.disabledOnInspect !== undefined) {
          if (fi.disabledOnInspect && disabledOnInspect) {
            fi.disabled = true;
          }
        }

        // Add
        if (fi.tableAddDialogFields !== undefined) {
          fi.tableAddClick = ($event) => {
            this.dialogOpener(fi, $event, fi.tableAddDialogFields);
          };
        }
        // Edit
        if (fi.tableEditDialogFields !== undefined) {
          fi.tableEditClick = ($event) => {
            this.dialogOpener(fi, $event, fi.tableEditDialogFields);
          };
          if (fi.tableDblClick === undefined) {
            fi.tableDblClick = ($event) => {
              this.dialogOpener(fi, $event, fi.tableEditDialogFields);
            };
          }
        }
        // Delete
        if (fi.tableDeleteDialogFields !== undefined) {
          fi.tableDeleteClick = ($event) => {
            this.dialogOpener(fi, $event, fi.tableDeleteDialogFields);
          };
        }
      });

      // bu islem listone servis sonucunda dolarak calisacak
      // zaten super de var di bu fazla olmus...
      this.formItems = pageMeta.formItems;
    }


    // console.log(pageMeta);
    this.viasListOneService();
  }

  dialogOpener(fi: FormItem, $event: any, field: DialogFields): void {
    if (field.data !== undefined) {
      if (field.data['row'] !== undefined) {
        delete field.data['row'];
      }
    }
    const data = {
      row: $event.item,
      parentRef: this,
      ...field.data
    };
    const panelClass: string[] = ['pageDialog'];
    if (field.className !== undefined) {
      panelClass.push(field.className);
    }
    this.tableDialog.open(
      field.openedPage, {
      panelClass,
      data
    })
      .afterClosed()
      .subscribe(response => {
        field.callBackFunction($event, response, fi, this);
      });
  }

  viasListOneService(): void {
    let sendData: object = this.data$;
    if (this.pageMeta.editInitDataFields !== undefined) {
      sendData = {
        ...sendData,
        ...this.pageMeta.editInitDataFields
      };
    }
    const pidx = this.editPid !== undefined && this.editPid > 0 ? this.editPid : this.pid;

    // this.pageMeta.inspectAid
    // this.viasService.send(pidx, this.aid, sendData).then(
    this.viasService.send(pidx, this.pageMeta.inspectAid, sendData).then(
      response => {
        if (response.error !== null && response.error !== undefined && response.error.length > 0) {
          this.globals.handleErrors(response.error);
        }
        this.viasServiceHandler(response);
      },
      err => {
        this.globals.handleErrors([err]);
      });

  }

  viasServiceHandler(r: ViasResponse): void {
    super.viasServiceHandler(r);
    if (r.data) {
      const x = this.responseFieldParserForForm(
        r.data,
        this.pageMeta.responseFields,
        this.pageMeta.formItems
      );
      this.formItems = x;

      // form init edildikten sonra,
      // datalar geldikten sonra
      // form ref ile icindeki value lari set et
      this.formItems.forEach(item => {
        // value "0" olarak gördüğünden edit sayfasında işlem yapmıyordu

        // son değişiklik sonrasında formRefx.form.controls boş olduğu için çalışmıyor
        if (this.formRefx.form.controls[item.name] !== undefined) {
          if (item.type === 'checkbox') {
            this.formRefx.form.controls[item.name].setValue(item.value * 1);
          } else if (item.type === 'datepicker') {
            const d: any = item.value * 1 === 0 ? null : new Date(item.value * 1000);
            this.formRefx.form.controls[item.name].setValue(d);
          } else {
            this.formRefx.form.controls[item.name].setValue(item.value);
          }
        }
        if (item.type === 'table') {
          item.tableButtonBarData = {
            ...item.tableButtonBarData,
            ...this.pageGeneralData
          };
        }
      });

      // sabit submit degerlerini ayarla
      this.formSubmitFields = {};
      if (this.pageMeta.formSubmitFields !== null &&
        this.pageMeta.formSubmitFields !== undefined &&
        this.pageMeta.formSubmitFields.length > 0
      ) {
        this.pageMeta.formSubmitFields.forEach(fsf => {
          let val = fsf.value;
          if (fsf.responseFieldType === ResponseFieldDataSourceType.formDataSource) {
            if (r.data[fsf.responseFieldName] !== undefined) {
              const datax = r.data[fsf.responseFieldName];
              val = datax[fsf.responseFieldId];
            }
          }
          this.formSubmitFields[fsf.postFieldName] = val;
        });
      }
    } else {
      this.formItems = this.pageMeta.formItems;
    }
  }
  formItemClickHandler($event: FormItem): void {
    if ($event.iconClick !== undefined) {
      $event.iconClick(this,
        this.storage, this.globals, this.viasService, this.next, this.route, this.translate, this.tableDialog
      );
    }
  }
  formChangeHandler($event: object): void {
    if (this.pageMeta.formChangeFunction !== undefined) {
      if (this.pageMeta.formChangeFunctionItems !== undefined) {
        this.pageMeta.formChangeFunctionItems.forEach(fi => {
          if ($event['itemName'] === fi) {
            this.pageMeta.formChangeFunction($event, this);
          }
        });
      }
    }
  }
  formTableEditHandler($event: any): void {
    this.tableAddDialogRun($event);
  }
  formSubmitHandler($event: FormEvent): void {
    console.log($event);
    console.log(this.formRefx);

    if (this.pageMeta.formBeforeSubmitFunction !== undefined) {
      this.pageMeta.formBeforeSubmitFunction(this, this.formRefx.form,
        this.storage, this.globals, this.viasService, this.next, this.route, this.translate
      );
    } else {
      const sendData: object = {};
      this.formItems.forEach(fi => {
        let val = $event[fi.name];
        if (fi.type === FieldTypes.DateCombo) {
          const d = new Date(val);
          val = d.getTime() / 1000;
        }
        sendData[fi.name] = val;
      });
      for (const key in this.formSubmitFields) {
        if (this.formSubmitFields[key]) {
          sendData[key] = this.formSubmitFields[key];
        }
      }
      this.viasService.send(this.pid, this.submitAid, sendData).then(
        response => {
          // super.viasServiceHandler(response);
          this.globals.viasAlert.show('successful', AlertType.Success);
          this.viasSubmitServiceHandler(response);
        },
        err => {
          this.globals.handleErrors([err]);
          // alert(err);
          // console.log(err);
        });
    }
  }

  viasSubmitServiceHandler(response: ViasResponse): void {
    if (response.error !== null && response.error !== undefined && response.error.length > 0) {
      this.globals.handleErrors(response.error);
    } else {
      if (this.pageMeta.formAfterSubmitFunction !== undefined) {
        this.pageMeta.formAfterSubmitFunction(response,
          this.storage, this.globals, this.viasService, this.next, this.route, this.translate
        );
      } else {
        switch (response.return_action) {
          // kendini guncelle
          case 'refresh':
          case 'refresh_self':
            this.viasListOneService();
            break;
          // formu kapat arkadaki sayfayi guncelle
          default:
          case '':
          case 'success':
            this.route.navigate(
              ['/' + this.moduleName + '/' + this.pageMeta.listPageName]
            );
            break;
        }
      }
    }
  }
}
